import type { TourSpec } from "./types";

export const tsmProfileTour: TourSpec = {
  id: "tsm-profile",
  version: 1,
  buildSteps: (t) => [
    {
      target: '[data-tour="tsm-guide-video"]',
      title: t("tsmProfile.video.title"),
      content: t("tsmProfile.video.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="tsm-minimum-price-config"]',
      title: t("tsmProfile.min.title"),
      content: t("tsmProfile.min.body"),
      placement: "top",
    },
    {
      target: '[data-tour="tsm-maximum-price-config"]',
      title: t("tsmProfile.max.title"),
      content: t("tsmProfile.max.body"),
      placement: "top",
    },
    {
      target: '[data-tour="tsm-normal-price-config"]',
      title: t("tsmProfile.normal.title"),
      content: t("tsmProfile.normal.body"),
      placement: "top",
    },
  ],
};
